import React from "react";
import styled from "styled-components";
import DashFooter from "./DashFooter";

const FeedbackCompo = () => {
  return (
    <>
      <FeedbackMain>Money Manager Feedback</FeedbackMain>
      <FeedbackDiv>
        <FeedbackGrid>
          <FeedbackCard>
            <p>
              We're building every day, making Money Manager better than ever.
              But we want to level up. So share your ideas and be part of what
              makes Money Manager powerful: our community of real users like
              you.
            </p>
            <h4>Here's How it Works</h4>
            <ul>
              <li>Start typing a suggestion</li>
              <li>
                Add comments with your perspective that needs to be update in
                Money Manager
              </li>
              <li>Click Submit, to share your valuable feedback with us.</li>
            </ul>
            <h4>Feedback is a Gift</h4>
            <span>
              Shape the future of Money Manager software to manage all your
              finances your feedback helps our team to improve user experience.
            </span>
          </FeedbackCard>
          <FeedbackForm>
            <h3>Give us Feedback</h3>
            <div>
              <label>Email</label>
              <input type="email" />
            </div>
            <div>
              <label>Subject</label>
              <input type="text" />
            </div>
            <div>
              <label>Messages</label>
              <textarea name="" id="" cols="30" rows="10"></textarea>
            </div>
            <div className="submit">Submit</div>
          </FeedbackForm>
        </FeedbackGrid>
      </FeedbackDiv>
      <DashFooter />
    </>
  );
};

export default FeedbackCompo;

const FeedbackMain = styled.h3`
  font-weight: 500;
  font-size: 35px;
  font-family: "Source Serif Pro", serif;
  color: rgb(0, 104, 74);
`;

const FeedbackDiv = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 5rem;
`;

const FeedbackGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
`;

const FeedbackCard = styled.div`
  p {
    font-weight: 500;
    font-size: 17px;
    color: rgb(0, 30, 43);
    margin-top: 0.5rem;
  }
  h4 {
    font-weight: 500;
    font-size: 23px;
    color: rgb(0, 30, 43);
    margin-top: 0.7rem;
  }
  ul {
    margin: 0.3rem 3rem;
    li {
      font-weight: 400;
      font-size: 16px;
      color: rgb(0, 30, 43);
      margin-bottom: 0.3rem;
    }
  }
  span {
    font-weight: 400;
    font-size: 17px;
    color: rgb(0, 30, 43);
    margin-bottom: 7rem;
  }
`;

const FeedbackForm = styled.form`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  margin-top: -15px;
  padding: 20px;
  border-radius: 8px;

  h3 {
    font-weight: 500;
    font-size: 30px;
    font-family: "Source Serif Pro", serif;
    color: rgb(0, 104, 74);
    margin-bottom: 0.8rem;
  }

  div {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 0.5rem;

    label {
      font-weight: 500;
      font-size: 15px;
      color: rgb(0, 30, 43);
      margin-bottom: 5px;
    }
    input {
      width: 100%;
      border: none;
      outline: none;
      padding: 10px;
      border: 2px solid rgb(58, 170, 53);
      border-radius: 6px;
    }
    textarea {
      width: 100%;
      height: 70px;
      border: none;
      outline: none;
      padding: 10px;
      border: 2px solid rgb(58, 170, 53);
      border-radius: 6px;
    }
  }
  .submit {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 8px 25px;
    background-color: #3aaa35;
    border-radius: 8px;
    color: #fff;
    width: 28%;
    cursor: pointer;
    margin-top: 1rem;
    font-weight: 500;
  }
`;
